import { Controller } from "@hotwired/stimulus"

// Submits the bot challenge form as soon as the ALTCHA widget has solved
// the proof-of-work challenge. The widget adds the solution as hidden
// "altcha" field to the form. The submit is delayed, so the user can see
// the check mark of the widget before the page changes.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 1000 }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  submit() {
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }
}
